/*eslint no-use-before-define:0 *///TODO REMOVE THIS
var _ = require('ES/lib/lodash');
var dd = require('ES/lib/dd');
var radio = require('ES/lib/radio');
var esUtils = require('ES/utils/esUtils');
var FormMixin = require('ES/widgets/forms/FormMixin');
var RadioMixin = require('ES/utils/RadioMixin');
var AuthedUserSession = require('../../../../../utils/AuthedUserSession');
var EventFormUnsavedChangeMixin = require('../../EventFormUnsavedChangeMixin');
var SlideOpenDown = require('../../../../widgets/SlideOpenDown');
var Constants = require('../../../../../utils/Constants.js');


/**
 *
 * @param dates
 * @returns {string}
 */
var formattedDate = function (note) {
    let date = new Date(Date.parse(_.get(note, "datetime_ISO8601")));
    return (date) ? esUtils.format_date(date, 'ddd, mmm d, yyyy') : "";
};

/**
 *
 * @param note
 * @returns {boolean}
 */
var isSystemNote = function (note) {
    return /^\*/.test(note.enteredby) || /^Event created as a/.test(note.content);
};

/**
 *
 * @param note
 * @returns {boolean}
 */
let isExternalNote = function (note) {
    return !_.isEmpty(_.get(note, "foreign_service"));
};


/**
 *
 * @param note
 * @returns {*}
 */
let enteredByToFullName = function (note) {
    if (isExternalNote(note)) {
        let r = "from ";
        let enteredby_parts = _.get(note, "enteredby", "").split('|'); //comes in like "KARMACRM|12345|Dave Tebow"
        r += (enteredby_parts.length > 2) ? ("contact " + _.last(enteredby_parts)) : _.get(note, "foreign_service", "").toUpperCase();

        return r;
    }

    return _.get(note, "enteredby_name", _.get(note, "enteredby"));
};


module.exports = dd.createClass({
    mixins: [RadioMixin],
    getInitialState: function () {
        return {
            hide_system_notes: true,
            hide_external_notes: false,
            show_new_note_form: false,
            saving_new_note: false,
            show_grab_instructions: false,
            expanded_note_id: false //one note at a time can be expanded
        };
    },
    __chkHideSysNotes: function (e) {
        this.setState({hide_system_notes: !!e.target.checked});
    },
    __chkHideExternalNotes: function (e) {
        this.setState({hide_external_notes: !!e.target.checked});
    },
    __toggleNewForm: esUtils.wrapPreventDefault(function () {
        this.setState({show_new_note_form: !this.state.show_new_note_form});
    }),
    __toggleGrabInstructions: esUtils.wrapPreventDefault(function () {
        this.setState({show_grab_instructions: !this.state.show_grab_instructions});
    }),
    __expandNote: esUtils.wrapPreventDefault(function (note_id) {
        this.setState({expanded_note_id: (this.state.expanded_note_id == note_id) ? 0 : note_id});
    }),
    componentWillMount: function () {
        var self = this;
        var closeNoteAfterItSaves = function (event, success) {
            var my_eid = self.props.event && self.props.event.eid;
            var this_eid = event && event.eid;
            if (self.state.saving_new_note && (my_eid == this_eid)) {
                self.setState({saving_new_note: false, show_new_note_form: !success && self.state.show_new_note_form});
            }
        };
        self.radio = {
            save_Event_succeeded: function (event, is_new, displaymessage) {
                closeNoteAfterItSaves(event, true);
            },
            save_Event_failed: function (event) {
                closeNoteAfterItSaves(event, false);
            }
        };
    },
    __onSubmit: function (data) {
        var event = _.cloneDeep(this.props.event);
        if (!_.isArray(event.Note)) {
            event.Note = [];
        }
        event.Note.push({
            id: 0,
            eid: event.eid,
            content: data.content,
            datetime: new Date(),
            enteredby: AuthedUserSession.MY_USERNAME
        });
        event.Note = _.sortBy(event.Note, 'datetime').reverse();
        radio('save_Event').broadcast(event);
        this.setState({saving_new_note: true});
    },
    render: function () {
        var event = this.props.event;
        var Displaylists = this.props.Displaylists;
        var read_only = this.props.read_only;

        var hide_system_notes = !!this.state.hide_system_notes;
        let hide_external_notes = !!this.state.hide_external_notes;

        var show_new_note_form = !!this.state.show_new_note_form;
        var show_grab_instructions = !!this.state.show_grab_instructions;

        let notes = _.get(event, "Note", []);

        if (hide_system_notes) {
            notes = _.reject(notes, isSystemNote);
        }

        if (!hide_external_notes) {
            notes = notes.concat(_.get(event, "ExternalNote", []));
        }

        //sort all notes by descending date
        notes.sort(function (a, b) {
                return Date.parse(_.get(b, "datetime_ISO8601", 0)) - Date.parse(_.get(a, "datetime_ISO8601", 0));
            }
        );
        var notemail_href = Constants.generateNotemailHREF(event, null, Displaylists);

        return dd.div({className: 'Notes'},

            dd.span({className: 'pull-right'},

                notemail_href
                    ? dd.a({href: '#', style: {marginRight: '2em'}, onClick: this.__toggleGrabInstructions}, 'link email')
                    : null,

                dd.label({style: {fontWeight: 'normal', marginRight: '2em'}},
                    dd.input({
                        type: 'checkbox',
                        checked: hide_system_notes,
                        onChange: this.__chkHideSysNotes
                    }),
                    ' hide system notes '
                ),
                dd.label({style: {fontWeight: 'normal', marginRight: '2em'}},
                    dd.input({
                        type: 'checkbox',
                        checked: hide_external_notes,
                        onChange: this.__chkHideExternalNotes
                    }),
                    ' hide CRM notes '
                ),
                show_new_note_form || read_only ? null : dd.button({className: 'btn btn-default btn-sm', onClick: this.__toggleNewForm},
                    dd.i({className: 'fa fa-plus'}), ' Add Note'
                )
            ),
            dd.h4({className: 'section-head'}, 'Notes'),
            dd.div({className: 'clearfix', style: {height: '1em'}}),

            !show_new_note_form ? null : NoteForm({
                event: event,
                onSubmit: this.__onSubmit,
                onCancel: this.__toggleNewForm
            }),

            notemail_href
                ? SlideOpenDown({open: show_grab_instructions, max_height: 80},
                GrabInstructions({
                    notemail_href,
                    closeFunction: this.__toggleGrabInstructions,
                    notemail_address: event.notemail_address,
                    copySuccess: this.state.copySuccess
                })
                )
                : null,

            dd.div({className: 'panel-group'},
                dd.div({className: 'panel panel-default'},
                    dd.div({className: 'panel-body'},
                        notes.length === 0 ? dd.a({href: "#", className: 'text-left emptylist', onClick: this.__toggleNewForm}, 'Add your first note.') : _.map(notes, function (note) {
                            return Note({
                                key: note.id,
                                note: note,
                                event: event,
                                display_expanded: (this.state.expanded_note_id == note.id),
                                onExpand: this.__expandNote
                            });
                        }, this)
                    )
                )
            )
        );
    }
});


var Note = dd.createClass({
    getInitialState: function () {
        return {editing: false, expanded: false};
    },
    __toggleEdit: esUtils.wrapPreventDefault(function () {
        this.setState({editing: !this.state.editing});
    }),

    __onExpand: esUtils.wrapPreventDefault(function () {
        this.props.onExpand(this.props.note.id);
    }),

    __onSubmit: function (data) {
        var event = _.cloneDeep(this.props.event);
        var note_id = this.props.note.id;
        _.each(event.Note, function (note) {
            if (note.id == note_id) {
                note.content = data.content;
            }
        });
        this.setState({editing: false});
        radio('save_Event').broadcast(event);
    },
    render: function () {
        var note = this.props.note;
        var event = this.props.event;
        var TRUNCATE_LENGTH = 300;

        var is_editable = (AuthedUserSession.MY_USERNAME === _.get(note, "enteredby", "").trim().toUpperCase() || _.get(note, "enteredby", "").trim().toUpperCase() === 'EMAIL') && !isSystemNote(note) && !isExternalNote(note);
        var editing = this.state.editing;

        var showExpander = false;

        let noteStyle = {
            transition: 'max-height .5s ease-in-out'
        };

        let classname = "Note";
        if (isExternalNote(note)) {
            classname += " external";
        }

        if ((note.content.length > TRUNCATE_LENGTH) && !this.props.display_expanded) {
            noteStyle.maxHeight = '220px';
            noteStyle.overflow = 'hidden';
            noteStyle.textOverflow = 'ellipsis';
            showExpander = true;
        } else if (this.props.display_expanded) {
            noteStyle.maxHeight = '500px';
            noteStyle.overflow = 'auto';
        } else {
            //neither expanded nor needs to be
        }

        return dd.div({className: classname},
            dd.div({className: 'text-muted noteSeparator'},
                enteredByToFullName(note),
                dd.span({className: 'pull-right'},
                    formattedDate(note)
                )
            ),
            editing ?
                NoteForm({
                    note: note,
                    event: event,
                    onSubmit: this.__onSubmit,
                    onCancel: this.__toggleEdit
                })
                :
                dd.div({className: "preserve-whitespace"},
                    dd.div({style: noteStyle}, (showExpander) ? note.content.substr(0, TRUNCATE_LENGTH) : note.content, (showExpander) ? '...' : null),
                    (showExpander) ? dd.a({href: '#', onClick: this.__onExpand}, '... show more') : null
                ),
            !is_editable || editing ? null : dd.div({style: {}},
                dd.a({href: '#', onClick: this.__toggleEdit}, dd.i({className: 'fa fa-edit'}), ' edit')
            )
        );
    }
});

var GrabInstructions = dd.createClass({

    getInitialState: function () {
        return {
            copySuccess: null
        };
    },

    __onCopy: esUtils.wrapPreventDefault(function (e) {
        let textArea = document.createElement("textarea");
        textArea.value = this.props.notemail_address;
        document.body.appendChild(textArea);
        textArea.select();
        document.execCommand("Copy");
        textArea.remove();

        this.setState({copySuccess: 'Copied!'});
    }),

    render() {
        let {notemail_address, notemail_href, closeFunction} = this.props;
        let copySuccess = _.get(this.state, "copySuccess", "");

        return dd.div(null,
            dd.div({className: 'alert alert-info', role: 'alert'},
                dd.span({className: "close", onClick: closeFunction}, dd.i({className: 'fa fa-times'})),
                'To copy email into this event\'s notes, add this address to your email\'s cc: ',
                dd.p({style: {fontWeight: 'bold', fontFamily: 'monospace', fontSize: '1.0em', padding: "0.2em", marginTop: "0.5em"}},
                    dd.span({ref: "myCopy"}, notemail_address),
                    dd.a({
                        onClick: this.__onCopy,
                        style: {marginLeft: '1em'}
                    }, dd.i({className: 'fa fa-clipboard'})),

                    dd.a({
                            href: notemail_href,
                            style: {marginLeft: '1em'}
                        }, dd.i({className: 'fa fa-envelope'})
                    ),
                    (!_.isEmpty(copySuccess)) && dd.span({style: {fontWeight: "normal", marginLeft: "1em", color: "white", backgroundColor: "#348bbd66", padding: "3px 5px", fontSize: "0.75em", borderRadius: "5px", fontFamily: "Helvetica Neue, Helvetica, Arial, sans-serif"}}, copySuccess)
                )
            )
        );
    }
});

var NoteForm = dd.createClass({
    mixins: [FormMixin, EventFormUnsavedChangeMixin],
    getInitialValuesSourceVersion: function (props) {
        var note = props.note;
        return note && note.id > 0 ? note.id : -1;
    },
    getInitialValues: function (props) {
        var note = props.note;
        return note && note.id > 0 ? {content: note.content} : {};
    },
    buildFields: function () {
        return {
            content: {
                type: 'textarea',
                placeholder: 'Enter a note about this event',
                validate: function (value) {
                    return (_.isString(value) && value.trim().length > 0) || 'Please enter a note about this event.';
                }
            }
        };
    },
    componentDidMount: function () {
        //focus the content field
        //dd.findDOMNode(this.refs.myref).focus();
    },
    render: function () {
        var note = this.props.note;
        var fields = this.buildFields();
        var errors = this.state.errors || {};

        return dd.form({className: 'NoteForm', onSubmit: this._form_onSubmit, style: {marginBottom: 15}},
            dd.div({className: 'form-group' + (errors['content'] ? ' has-error' : ''), style: {marginBottom: '.5em'}},
                dd.div(null,
                    this._form_buildInput(fields['content'], 'content'),
                    errors['content'] ? dd.span({className: 'help-block'}, errors['content']) : null
                )
            ),
            dd.div({className: 'form-group'},
                dd.div(null,
                    dd.button({type: 'submit', className: 'btn btn-primary btn-sm'},
                        note && note.id > 0 ? 'Save Note' : 'Save'
                    ),
                    ' ',
                    !this.props.onCancel ? null : dd.button({className: 'btn btn-default btn-sm', onClick: this.props.onCancel}, 'Cancel')
                )
            )
        );
    }
});



// WEBPACK FOOTER //
// ./src/components/main_view/event_area/tabs/details/Notes.js